import React from "react";
import InputFactory from "../../../../components/InputFactory";
import { dialog } from "nq-component";
import { object } from "framer-motion/m";

function DialogCreate({ schema, objects, onChangeData, handleSubmit }) {
  function handleChange(value, field) {
    onChangeData(value, field);
  }

  return (
    <>
      <div
        className="  p-4 rounded"
        style={{ maxWidth: "450px", margin: "auto" }}
      >
        <div
          className="d-flex align-items-center mb-3"
          style={{ color: "#d18237" }}
        >
          <div className="bg-light p-3 rounded-circle">
            <i className="bi bi-plus-circle  fs-4"></i>
          </div>
          <h5 className="fw-bold ms-2">Create Job Post</h5>
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Position Title</label>
          <InputFactory
            type="String"
            field="positionTitle"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter position"
            required
            defaultValue={objects?.positionTitle}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Slot Vacancy</label>
          <InputFactory
            type="Number"
            field="slotVacancy"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter slot"
            defaultValue={objects?.slotVacancy}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Qualification Standard</label>
          <InputFactory
            type="String"
            _type="Text"
            field="qualificationStandard"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter qualification standard"
            defaultValue={objects?.qualificationStandard}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Job Description</label>
          <InputFactory
            type="String"
            _type="Text"
            field="jobDescription"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter description"
            defaultValue={objects?.jobDescription}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Deadline</label>
          <InputFactory
            type="Date"
            field="deadline"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter deadline"
            defaultValue={
              objects?.deadline
                ? new Date(objects.deadline).toISOString().split("T")[0]
                : ""
            }
          />
        </div>

        <div className="d-flex justify-content-center">
          <button
            className="btn text-white px-4 me-2"
            style={{ backgroundColor: "#d18237" }}
            onClick={() => handleSubmit()}
          >
            {objects?.id ? "Update" : "Confirm"}
          </button>
          <button
            className="btn px-4"
            onClick={() => dialog.close()}
            style={{ backgroundColor: "#d0d0d0" }}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
}

export default DialogCreate;
